import styles from '@/components/Common/SideNav/SideNav.styles';
import { DashboardUserType } from '@/utils/enums';
import { Session } from '@/utils/session/model';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';

const ADMIN_MENU_LINKS = [
  {
    to: '/admin/buyer',
    icon: <ShoppingBagOutlinedIcon />,
    label: 'Compradores',
  },
  {
    to: '/admin/seller',
    icon: <StorefrontOutlinedIcon />,
    label: 'Vendedores',
  },
  {
    to: '/admin/products',
    icon: <CategoryOutlinedIcon />,
    label: 'Productos',
  },
  {
    to: '/admin/orders',
    icon: <ReceiptLongOutlinedIcon />,
    label: 'Pedidos',
  },
  {
    to: '/admin/carts',
    icon: <ShoppingCartOutlinedIcon />,
    label: 'Carritos',
  },
];

function getSellerMenuLinks() {
  return [
    {
      to: `/seller/orders`,
      icon: <ReceiptLongOutlinedIcon />,
      label: 'Pedidos',
    },
    {
      to: `/seller/products`,
      icon: <CategoryOutlinedIcon />,
      label: 'Productos',
    },
  ];
}

export function getSideBarMenus(session: Session | undefined | null) {
  switch (session?.type) {
    case DashboardUserType.ADMIN:
      return ADMIN_MENU_LINKS;
    case DashboardUserType.SELLER:
      return getSellerMenuLinks();
    default:
      return [];
  }
}

// FUNCTIONS

export function GET_WRAPPER_STYLES(collapse: boolean) {
  return {
    ...styles.wrapper,
    ...(collapse ? styles.wrapper.collapsed : {}),
  };
}
